import React, { useEffect, useState } from "react";
import group from "../../../assets/home_images/group_kids.svg";
import { useLocation, useNavigate } from "react-router-dom";
import TestimonialsComponent from "../../../components/testimonials";
import { API_BASE_URL } from "../../../config/apiConfig";
import WaitlistSection from "../../../components/waitlist";
import WaitlistModal from "../../../components/UniversityWaitlist";

const HomePage = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [isOpen, setIsOpen] = useState(false);

    useEffect(() => {
        if (location.hash) {
            const id = location.hash.replace("#", "");
            const element = document.getElementById(id);

            if (element) {
                // Small delay ensures the DOM is fully painted before scrolling
                setTimeout(() => {
                    element.scrollIntoView({ behavior: "smooth", block: "start" });
                }, 200);
            }
        }
    }, [location]);

    return (
        <div className="bg-gradient-to-br from-blue-50 to-white text-black">
            {/* Hero Section */}
            <section
                id="home"
                className="min-h-screen pt-32 sm:pt-28 flex flex-col justify-center items-center relative"
                style={{
                    backgroundImage:
                        'linear-gradient(rgba(0,0,0,0.6), rgba(0,0,0,0.6)), url("https://images.unsplash.com/photo-1523240795612-9a054b0db644?ixlib=rb-4.0.3&auto=format&fit=crop&w=1920&q=80")',
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    backgroundAttachment: "fixed",
                }}
            >
                <div className="container mx-auto flex flex-col md:flex-row items-center justify-between px-6 relative z-10">
                    {/* Left Text */}
                    <div className="text-center md:text-left flex-1">
                        <h1
                            className="text-4xl sm:text-5xl md:text-6xl font-extrabold mb-6 leading-tight
                   text-white"
                        >
                            {/* Learning Made Easy <br />
                            <span className="text-yellow-300">From JSS1 to SS3</span> */}
                            Learning Made Easy <br />
                            <span className="text-yellow-300">For WAEC & JAMB Success</span>
                        </h1>
                        {/* <p
                            className="text-lg sm:text-xl max-w-xl mx-auto md:mx-0 
                   text-gray-100 mb-8"
                        >
                            Explore study materials, past questions, notes, and interactive quizzes
                            for every class from Junior Secondary (JSS1–3) to Senior Secondary
                            (SS1–3). Prepare confidently for your subjects and national exams — all
                            in one place.
                        </p> */}

                        <p className="text-lg sm:text-xl max-w-xl mx-auto md:mx-0 text-gray-100 mb-8">
                            Prepare smarter for <strong>WAEC, JAMB, and NECO</strong> with up-to-date
                            past questions, detailed solutions, exam-focused notes, and interactive
                            quizzes — all designed to help you pass confidently.
                        </p>

                        <div className="flex flex-col sm:flex-row gap-4 justify-center md:justify-start">
                            <button
                                // onClick={() => navigate("/free-login ")}

                                onClick={() => navigate("/signup")}
                                className="bg-yellow-500 text-gray-900 md:bg-yellow-500 md:text-gray-900
                     px-8 py-4 rounded-full text-lg font-semibold 
                     hover:bg-yellow-600 transition-all transform hover:scale-105 shadow-lg"
                            >
                                {/* Get Started Free */}
                                Start WAEC & JAMB Prep
                            </button>
                            {/* <button
                                onClick={() => {
                                    const section = document.getElementById("waitlist");
                                    if (section) {
                                        section.scrollIntoView({ behavior: "smooth" });
                                    }
                                }}
                                className="bg-yellow-500 text-gray-900 md:bg-yellow-500 md:text-gray-900
    px-8 py-4 rounded-full text-lg font-semibold 
    hover:bg-yellow-600 transition-all transform hover:scale-105 shadow-lg"
                            >
                                Join the Waitlist
                            </button> */}
                        </div>
                    </div>

                    {/* Right Side Content */}
                    <div className="flex justify-center mt-8 md:mt-0 flex-1">
                        {/* Desktop: Show Students Image */}
                        <img
                            src={group}
                            alt="Students"
                            className="hidden md:block w-full max-w-md md:max-w-lg drop-shadow-xl"
                        />

                        <div className="md:hidden bg-white/20 backdrop-blur-sm rounded-xl p-6 text-white text-center shadow-lg">
                            <p className="text-lg font-semibold mb-2">
                                Get Ready Now
                            </p>
                            <p className="text-sm opacity-80">
                                Study with real exam questions
                            </p>
                        </div>

                        {/* Mobile: Show Something Else (example: a quote card or stats) */}
                        {/* <div className="md:hidden bg-white/20 backdrop-blur-sm rounded-xl p-6 text-white text-center shadow-lg">
                            <p className="text-lg font-semibold mb-2">1000+ Students Learning</p>
                            <p className="text-sm opacity-80">Join the community today!</p>
                        </div> */}
                    </div>
                </div>
            </section>



            {/* Features Section */}
            {/* <section className="py-20 bg-white">
                <div className="container mx-auto px-6 text-center">
                    <h2 className="text-4xl font-bold mb-12">Your All-in-One Study Companion</h2>
                    <div className="grid gap-8 md:grid-cols-3">
                        <div className="p-8 bg-blue-50 rounded-2xl shadow-md">
                            <h3 className="text-2xl font-semibold mb-4 text-[#2148C0]">Complete Coverage</h3>
                            <p className="text-gray-600">
                                Access subjects across all classes — from JSS1 through SS3 — including Math, English, Science,
                                and more. No topic left behind!
                            </p>
                        </div>
                        <div className="p-8 bg-blue-50 rounded-2xl shadow-md">
                            <h3 className="text-2xl font-semibold mb-4 text-[#2148C0]">Past Questions & Solutions</h3>
                            <p className="text-gray-600">
                                Practice with questions similar to: WAEC, JAMB, NECO questions, with detailed step-by-step solutions
                            </p>
                        </div>
                        <div className="p-8 bg-blue-50 rounded-2xl shadow-md">
                            <h3 className="text-2xl font-semibold mb-4 text-[#2148C0]">Interactive Quizzes</h3>
                            <p className="text-gray-600">
                                Test yourself with quizzes after each topic, track your progress,
                                and get instant feedback to stay on top.
                            </p>
                        </div>
                    </div>
                </div>
            </section> */}


            {/* Features Section */}
            <section className="py-20 bg-white">
                <div className="container mx-auto px-6 text-center">
                    <h2 className="text-4xl font-bold mb-12">
                        Everything You Need to Pass WAEC & JAMB
                    </h2>

                    <div className="grid gap-8 md:grid-cols-3">
                        <div className="p-8 bg-blue-50 rounded-2xl shadow-md">
                            <h3 className="text-2xl font-semibold mb-4 text-[#2148C0]">
                                Exam-Focused Notes
                            </h3>
                            <p className="text-gray-600">
                                Learn only what matters for WAEC, JAMB, and NECO —
                                structured explanations based on the official syllabus.
                            </p>
                        </div>

                        <div className="p-8 bg-blue-50 rounded-2xl shadow-md">
                            <h3 className="text-2xl font-semibold mb-4 text-[#2148C0]">
                                WAEC & JAMB Past Questions
                            </h3>
                            <p className="text-gray-600">
                                Practice real past questions with clear, step-by-step
                                solutions so you understand how exam answers are marked.
                            </p>
                        </div>

                        <div className="p-8 bg-blue-50 rounded-2xl shadow-md">
                            <h3 className="text-2xl font-semibold mb-4 text-[#2148C0]">
                                Timed Practice Quizzes
                            </h3>
                            <p className="text-gray-600">
                                Simulate real exam conditions, track your scores,
                                and improve speed and accuracy before exam day.
                            </p>
                        </div>
                    </div>
                </div>
            </section>


            {/* Why Choose Us Section with Unsplash Background */}
            {/* <section
                className="py-24 relative bg-cover bg-center bg-fixed"
                style={{
                    backgroundImage: 'url("https://images.unsplash.com/photo-1522202176988-66273c2fd55f?ixlib=rb-4.0.3&auto=format&fit=crop&w=2071&q=80")'
                }}
            >
                <div className="absolute inset-0 bg-black bg-opacity-60"></div>

                <div className="container mx-auto px-6 relative z-10">
                    <div className="text-center mb-16">
                        <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
                            Why 1,000+ Students Trust Us
                        </h2>
                        <p className="text-xl text-blue-100 max-w-3xl mx-auto">
                            Join thousands of successful students who have transformed their academic journey with our comprehensive learning platform.
                        </p>
                    </div>

                    <div className="grid gap-8 md:grid-cols-2 lg:grid-cols-4">
                        <div className="text-center p-6 bg-white bg-opacity-10 backdrop-blur-sm rounded-2xl border border-white border-opacity-20">
                            <div className="text-4xl font-bold text-white mb-2">95%</div>
                            <div className="text-blue-100 font-semibold">Improvement  Rate</div>
                            <p className="text-sm text-blue-200 mt-2">Students improve on their target subjects</p>
                        </div>

                        <div className="text-center p-6 bg-white bg-opacity-10 backdrop-blur-sm rounded-2xl border border-white border-opacity-20">
                            <div className="text-4xl font-bold text-white mb-2">24/7</div>
                            <div className="text-blue-100 font-semibold">Access</div>
                            <p className="text-sm text-blue-200 mt-2">Study anytime, anywhere at your pace</p>
                        </div>

                        <div className="text-center p-6 bg-white bg-opacity-10 backdrop-blur-sm rounded-2xl border border-white border-opacity-20">
                            <div className="text-4xl font-bold text-white mb-2">500+</div>
                            <div className="text-blue-100 font-semibold">Past Questions</div>
                        </div>

                        <div className="text-center p-6 bg-white bg-opacity-10 backdrop-blur-sm rounded-2xl border border-white border-opacity-20">
                            <div className="text-4xl font-bold text-white mb-2">15+</div>
                            <div className="text-blue-100 font-semibold">Subjects</div>
                            <p className="text-sm text-blue-200 mt-2">Complete curriculum coverage</p>
                        </div>
                    </div>

                    <div className="mt-16 text-center">
                        <button
                            onClick={() => navigate("/signup")}
                            className="bg-[#2148C0] text-white px-10 py-4 rounded-full text-lg font-semibold hover:bg-blue-700 transition-all transform hover:scale-105 shadow-lg"
                        >
                            Start Your Success Story
                        </button>
                    </div>
                </div>
            </section> */}

            <section
                className="py-24 relative bg-cover bg-center bg-fixed"
                style={{
                    backgroundImage:
                        'url("https://images.unsplash.com/photo-1522202176988-66273c2fd55f?ixlib=rb-4.0.3&auto=format&fit=crop&w=2071&q=80")'
                }}
            >
                <div className="absolute inset-0 bg-black bg-opacity-60"></div>

                <div className="container mx-auto px-6 relative z-10">
                    <div className="text-center mb-16">
                        <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
                            Trusted by WAEC & JAMB Candidates
                        </h2>
                        <p className="text-xl text-blue-100 max-w-3xl mx-auto">
                            Thousands of students use our platform every year to prepare,
                            practice, and pass their national exams.
                        </p>
                    </div>

                    <div className="grid gap-8 md:grid-cols-2 lg:grid-cols-4">
                        <div className="text-center p-6 bg-white bg-opacity-10 backdrop-blur-sm rounded-2xl">
                            <div className="text-4xl font-bold text-white mb-2">95%</div>
                            <div className="text-blue-100 font-semibold">Pass Improvement</div>
                        </div>

                        <div className="text-center p-6 bg-white bg-opacity-10 backdrop-blur-sm rounded-2xl">
                            <div className="text-4xl font-bold text-white mb-2">10+</div>
                            <div className="text-blue-100 font-semibold">Years of Questions</div>
                        </div>

                        <div className="text-center p-6 bg-white bg-opacity-10 backdrop-blur-sm rounded-2xl">
                            <div className="text-4xl font-bold text-white mb-2">500+</div>
                            <div className="text-blue-100 font-semibold">WAEC & JAMB Questions</div>
                        </div>

                        <div className="text-center p-6 bg-white bg-opacity-10 backdrop-blur-sm rounded-2xl">
                            <div className="text-4xl font-bold text-white mb-2">15+</div>
                            <div className="text-blue-100 font-semibold">Exam Subjects</div>
                        </div>
                    </div>
                </div>
            </section>

            <TestimonialsComponent />
            {/* <div className="w-fit m-auto">
                <button
                    onClick={() => setIsOpen(true)}
                    className="bg-blue-700 text-[white] px-8 py-4 rounded-full text-lg font-semibold hover:bg-blue-200 transition-all mb-5"
                >
                    Join University Waitlist
                </button>

            </div> */}

            {/* Call to Action */}
            {/* <section className="py-20 bg-[#2148C0] text-white text-center">
                <h2 className="text-4xl font-bold mb-6">From Classwork to Exams, We've Got You Covered</h2>
                <p className="text-lg mb-8">Start learning today and move closer to your academic goals.</p>
                <button
                    onClick={() => navigate("/signup")}
                    className="bg-white text-[#2148C0] px-8 py-4 rounded-full text-lg font-semibold hover:bg-gray-200 transition-all"
                >
                    Join Free Now
                </button>
            </section> */}

            <section className="py-20 bg-[#2148C0] text-white text-center">
                <h2 className="text-4xl font-bold mb-6">
                    Get Ready for WAEC & JAMB — The Smart Way
                </h2>
                <p className="text-lg mb-8">
                    Study with confidence, practice real questions, and walk into the exam hall prepared.
                </p>
                <button
                    onClick={() => navigate("/signup")}
                    className="bg-white text-[#2148C0] px-8 py-4 rounded-full text-lg font-semibold hover:bg-gray-200 transition-all"
                >
                    Start Practicing Free
                </button>
            </section>


            <WaitlistModal isOpen={isOpen} onClose={() => setIsOpen(false)} />

        </div>
    );
};

export default HomePage;